import { render, staticRenderFns } from "./OlvideContrasena.vue?vue&type=template&id=0218d5f0&scoped=true&lang=pug"
import script from "./OlvideContrasena.vue?vue&type=script&lang=js"
export * from "./OlvideContrasena.vue?vue&type=script&lang=js"
import style0 from "./OlvideContrasena.vue?vue&type=style&index=0&id=0218d5f0&prod&scoped=true&lang=css"
import style1 from "./OlvideContrasena.vue?vue&type=style&index=1&id=0218d5f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0218d5f0",
  null
  
)

export default component.exports